module.exports = __webpack_public_path__ + "img/minus-icon-gray.9c2cfb21.svg";